import { IComboBox, IComboBoxOption, IComboBoxStyles, VirtualizedComboBox } from "@fluentui/react";
import { FormEvent, useState } from "react";

interface IComboBoxComponent {
    text: string;
      required?: boolean;
      data: IComboBoxOption[];
      disable?: boolean;
      placeholder?: string;
      width?: string;
      selectedKeys?: string[] | number[] | null;
      onOptionSelect?: (
        event: FormEvent<IComboBox>,datafprm:any[] ,option?: IComboBoxOption | undefined,
      ) => void;
}

interface ISelectedOptions {
  text: string;
  key: string | number;
}
export const ComboBoxMultiComponent=(props:IComboBoxComponent)=>{
  const [dataSeleccionada, setDataSeleccionada] = useState<ISelectedOptions[]>([]);

const comboBoxStyles: Partial<IComboBoxStyles> = {
    root: {
      width: '100%'
    },
    callout: {
      minWidth: "275px", 
      width: "275px",
      maxHeight: props.data && props.data.length >= 10 ? 50 : undefined,
      overflowY: 'auto'
    },
    optionsContainer: {
      minWidth: "275px", 
    },
};
const onSelect = (event: FormEvent<IComboBox>, option?: IComboBoxOption | undefined) => {
    if(option){
        if(option.selected){
        let data = dataSeleccionada
        data.push({key:option.key,text:option.text})
        setDataSeleccionada(data)
        if (props.onOptionSelect) props.onOptionSelect(event,data ,option);
        }else{
          let errase = dataSeleccionada.filter((item)=>item.key!=option.key)
          setDataSeleccionada(errase)
          if (props.onOptionSelect) props.onOptionSelect(event,errase ,option);

        }
        
    }
}

return (
    <div
      style={{
        width: props.width == null ? "100%" : props.width,
        minWidth: "100px",
        marginTop: "20px",
        display: "flex",
        flexDirection: "column",
      }}
    >
    <VirtualizedComboBox options={props.data}
    label={props.text}
    disabled={props.disable || false}
    allowFreeform
    multiSelect
    autoComplete="on"
    styles={comboBoxStyles}
    placeholder={props.placeholder}
    selectedKey={props.selectedKeys}
    onChange={onSelect}
        //errorMessage={props.required && !value ? `El campo ${props.text} es requerido.` : undefined}
    />



    </div>)
}